import React from "react";
import { Ban, CalendarSync, FileDown, Mail, Pencil, UserPlus } from "lucide-react";

export default function EventActionMenu({
    roleConfig,
    registrationAction,
    absenceAction,
    onEdit,
    onReplanify,
    onCancel,
    onAssign,
    onSendInvitation,
    onDownloadAttendanceSheet,
}) {
    const actions = [
        registrationAction && {
            key: "register",
            label: registrationAction.label,
            icon: UserPlus,
            onClick: registrationAction.onClick,
            disabled: registrationAction.disabled,
            title: registrationAction.reason || registrationAction.label,
        },
        absenceAction && {
            key: "declare-absence",
            label: absenceAction.label,
            icon: Ban,
            onClick: absenceAction.onClick,
            disabled: absenceAction.disabled,
            title: absenceAction.reason || absenceAction.label,
        },
        roleConfig.canEdit && { key: "edit", label: "Modifier", icon: Pencil, onClick: onEdit },
        roleConfig.canReplanify && { key: "replanify", label: "Replanifier", icon: CalendarSync, onClick: onReplanify },
        roleConfig.canCancel && { key: "cancel", label: "Annuler", icon: Ban, onClick: onCancel, tone: "danger" },
        roleConfig.canAssign && { key: "assign", label: "Affecter", icon: UserPlus, onClick: onAssign },
        roleConfig.canSendInvitations && { key: "invite", label: "Envoyer invitations", icon: Mail, onClick: onSendInvitation },
        roleConfig.canDownloadAttendanceSheet && {
            key: "attendance",
            label: "Feuille d'émargement",
            icon: FileDown,
            onClick: onDownloadAttendanceSheet,
        },
    ].filter(Boolean);

    if (!actions.length) return null;

    return (
        <div className="calendar-action-menu">
            {actions.map((action) => {
                const Icon = action.icon;
                return (
                    <button
                        key={action.key}
                        type="button"
                        className={`calendar-action-btn ${action.tone === "danger" ? "is-danger" : ""}`}
                        onClick={action.onClick}
                        disabled={action.disabled}
                        title={action.title}
                    >
                        <Icon size={14} />
                        <span>{action.label}</span>
                    </button>
                );
            })}
        </div>
    );
}
